export const campaigns = [
    {id: 1, name: "Sodexo %20 Kampanyası"},
    {id: 2, name: "Periyodik Bakım Kampanyası"},

]
